
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#C3AFA3"}},[_c('rect',{attrs:{"width":"1.5","height":"6.75","x":"15","y":"5.625","rx":".188"}}),_c('rect',{attrs:{"width":"6.75","height":"1.5","x":"5.625","y":"1.5","rx":".188"}}),_c('rect',{attrs:{"width":"4.5","height":"4.5","rx":"1.5"}}),_c('rect',{attrs:{"width":"4.5","height":"4.5","x":"13.5","rx":"1.5"}}),_c('rect',{attrs:{"width":"4.5","height":"4.5","x":"13.5","y":"13.5","rx":"1.5"}}),_c('path',{attrs:{"d":"M9 9.873c0-.05.02-.097.055-.133l1.687-1.687a.187.187 0 01.32.132v1.19a.562.562 0 101.126 0v-3a.565.565 0 00-.563-.563h-3a.563.563 0 000 1.125h1.19a.188.188 0 01.132.32L8.26 8.946A.188.188 0 018.127 9h-4.94A.188.188 0 013 8.812v-3a.188.188 0 00-.188-.187H1.688a.188.188 0 00-.188.188v9.937c0 .414.336.75.75.75h9.938a.187.187 0 00.187-.188v-1.125a.187.187 0 00-.188-.187h-3A.187.187 0 019 14.812V9.873zm-6 .44c0-.104.084-.188.188-.188h4.5c.103 0 .187.084.187.188v4.5a.187.187 0 01-.188.187H3.375A.375.375 0 013 14.625v-4.313z"}})])])
          )
        }
      }
    